const $ = require('js/sw-jquery/sw-jquery');
const sw = require('js/lib/sw');
const moment = require('moment');
require('moment-timezone');

$(document).ready(function () {
  const $rushCutoffMsg = $('[data-sw-rush-cutoff-message]');

  function getLocalCutoffTime(utcCutOffTime){
    const now = moment.utc();
          now.hours(utcCutOffTime);
          now.minutes(0);
    const nowLocal = now.local();
    const zoneName = moment.tz.guess();
    const zoneAbbr = moment.tz(zoneName).zoneAbbr();

    return nowLocal.format('h:mm a') + ' ' + zoneAbbr;
  }

  function displayRushMessage() {
      const rushCutOffTime = $rushCutoffMsg.data('swRushCutoffMessage');
      const localCutOffTime = getLocalCutoffTime(rushCutOffTime);
      $('[data-sw-rush-cutoff-time]').html(localCutOffTime);
  }

  sw.on('update-rush-cutoff-message', function (showRushCutOffMsg) {
      if(showRushCutOffMsg){
        $rushCutoffMsg.removeClass('sw--is-hidden');
        displayRushMessage();
      }
      else {
        $rushCutoffMsg.addClass('sw--is-hidden');
      }
  });

  if ($rushCutoffMsg.is(':visible')) {
    displayRushMessage();
  }
});
